import React, { useState } from 'react';
import { Page } from '../types';

interface AdminLoginProps {
  setPage: (page: Page) => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ setPage }) => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate auth with updated credentials
    setTimeout(() => {
      if (credentials.email === 'abdulrahmanadebambo@gmail.com' && credentials.password === 'adeola123') {
        localStorage.setItem('fintrack_is_admin', 'true');
        setPage('admin-dashboard');
      } else {
        setError('Invalid administrative credentials. Please check your email or secret key.');
        setIsLoading(false);
      }
    }, 1500);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-4">
      <div className="max-w-md w-full animate-reveal">
        <div className="text-center mb-10">
          <div onClick={() => setPage('home')} className="inline-block cursor-pointer mb-8">
            <img 
              src="https://res.cloudinary.com/dohuj4mx9/image/upload/v1769023542/fintrack_logo_unique_v1-removebg-preview_oc4bqx.png" 
              alt="FinTrack Logo" 
              className="w-32 h-32 object-contain mx-auto"
            />
          </div>
          <h1 className="text-3xl font-display font-bold text-slate-900 dark:text-white">Admin Console</h1>
          <p className="text-slate-500 mt-2">Secure access for compliance officers only.</p>
        </div>

        <div className="bg-white dark:bg-slate-900 p-8 rounded-[32px] shadow-2xl border border-slate-100 dark:border-slate-800">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-xs font-black uppercase tracking-widest text-slate-500 mb-2">Internal Email</label>
              <input 
                type="email"
                required
                className="w-full px-5 py-4 bg-slate-50 dark:bg-slate-800 border-none rounded-2xl focus:ring-2 focus:ring-primary text-slate-900 dark:text-white"
                placeholder="officer@fintrack.ng"
                value={credentials.email}
                onChange={e => setCredentials({...credentials, email: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-xs font-black uppercase tracking-widest text-slate-500 mb-2">Secret Key</label>
              <input 
                type="password"
                required
                className="w-full px-5 py-4 bg-slate-50 dark:bg-slate-800 border-none rounded-2xl focus:ring-2 focus:ring-primary text-slate-900 dark:text-white"
                placeholder="••••••••"
                value={credentials.password}
                onChange={e => setCredentials({...credentials, password: e.target.value})}
              />
            </div>

            {error && <p className="text-red-500 text-xs font-bold text-center">{error}</p>}

            <button 
              disabled={isLoading}
              type="submit" 
              className="w-full py-5 bg-primary text-white font-bold rounded-2xl shadow-xl hover:translate-y-[-2px] transition-all disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {isLoading ? 'Verifying...' : 'Access Portal'}
              {!isLoading && <span className="material-symbols-rounded">admin_panel_settings</span>}
            </button>
          </form>
          
          <div className="mt-6 p-4 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-dashed border-slate-200 dark:border-slate-700">
            <p className="text-[10px] text-slate-400 font-bold uppercase text-center mb-1">Demo Access Credentials</p>
            <p className="text-[10px] text-slate-500 text-center font-mono">Email: abdulrahmanadebambo@gmail.com</p>
            <p className="text-[10px] text-slate-500 text-center font-mono">Secret: adeola123</p>
          </div>
        </div>
        
        <button 
          onClick={() => setPage('home')}
          className="w-full mt-8 text-slate-400 hover:text-primary transition-colors text-sm font-bold flex items-center justify-center gap-2"
        >
          <span className="material-symbols-rounded text-base">arrow_back</span>
          Return to public site
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;